import { useAppContext } from '@/contexts/AppContext';
import { useUnit } from '@/hooks/units';
import { getAddressDescription } from '@/utils/addresses';
import { getBathroomCount } from '@/utils/units';
import { type FC } from 'react';

interface Props {
  unitId: number;
}

const ScheduleTourPropertyDetails: FC<Props> = ({ unitId }) => {
  const { community } = useAppContext();
  const { data: unit } = useUnit.useSuspenseQuery([community.id, unitId]);

  const property = unit?.property;

  if (!property || !unit) {
    return null;
  }

  return (
    <div className="mb-6 bg-primary-50 border border-primary-200 rounded-none p-4 flex items-start">
      <div className="flex-shrink-0">
        <img src={unit.images?.[0].thumbnailUrl} className="w-16 h-16 object-cover rounded-none" />
      </div>
      <div className="ml-4">
        <h3 className="text-sm font-medium text-primary-800">Inquiring about:</h3>
        <p className="text-lg font-bold text-primary-900">
          {getAddressDescription(property.address)}
        </p>
        <p className="text-sm text-primary-700">
          {unit.bedroomCount} Bed |{' '}
          {getBathroomCount({
            fullBathroomCount: unit.fullBathroomCount,
            halfBathroomCount: unit.halfBathroomCount,
            quarterBathroomCount: unit.quarterBathroomCount,
            threeQuarterBathroomCount: unit.threeQuarterBathroomCount,
          })}{' '}
          Bath
        </p>
      </div>
    </div>
  );
};

export default ScheduleTourPropertyDetails;
